import ViewMore from "./viewMore";
import Mail from "../../../../Components/Icons/Mail";
import Phone from "../../../../Components/Icons/Phone";
import { SmallsubHeading } from "../../../../Components/Utils/Heading";
import { Link, useParams } from "react-router-dom";
import { TextSM } from "../../../../Components/Text/NormalText";
import MoreOptionsCard from "../../../../Components/Utils/MoreOptionsCard";

const CardView =({item, key, fetcher,data}) => {
  const {officeId} =useParams();
  return (
      <div key={key} className='w-full md:w-[30%] lg:w-[23%] bg-white p-2 rounded shadow-md border-blue-100 border'>
          <div className='w-full flex'>
              <div className='w-11/12'>
                  <div className='w-full flex justify-start gap-2'>
                      {/*<div className=' w-8 h-8 bg-slate-400 rounded-full overflow-hidden mt-0.5'>
                          {item.userImage && <img src={item.userImage} width='35px' alt={`${item.userImage}`} />}
                      </div> */}
                      <div className='text-sm w-8 h-8 bg-slate-400 rounded-full overflow-hidden mt-0.5 flex items-center justify-center'>
                          {item?.image?.file ? item?.image?.file && <img src={item.image?.file} width='35px' alt={`${item?.image?.file}`} className='object-cover' /> : item?.job_role[0]}
                      </div>
                      <div className='flex flex-col'>
                          <p className=' text-[14px] font-medium  text-[#4F4768] truncate w-32'>
                          <Link to={`/main/${officeId}/contacts/rental-man/view/${item?.id}`} state={{data:item}}>
                          {item?.job_role || "-"}</Link></p>
                          <p className='text-[#9A95A8] text-xs font-normal'>Rental Manpower ID: {item?.id || "-"}</p>
                      </div>
                  </div>
              </div>
              <div className='w-1/12 flex justify-end'>
              <MoreOptionsCard
                  data={item}
                  fetcher={fetcher}
                  id={item?.id}
                  removevalue={item?.job_role || "undefined"}
                  url={`/manpower-role/`}
                  moduleName={"Manpower"}
                  from={`/main/${officeId}/contacts/rental-man/`}
                  editLink={`/main/${officeId}/contacts/rental-man/edit/`}
                  viewLink={`/main/${officeId}/contacts/rental-man/view/`}
                />
              </div>
          </div>
          <div className='w-full flex justify-end'>
              {/* <div>
            <span>Role:</span><p>{role || ''}</p>
          </div> */}
              {
                  item?.status === 'Active' ? <div className='w-2 h-2 bg-[#08B624] rounded-full flex justify-end'></div> :
                      item?.status === 'In Active' || item?.status === 'In active' ? <div className='w-2 h-2 bg-[#FF3232] rounded-full flex justify-end'></div> :
                          <div className='w-2 h-2 bg-slate-300 rounded-full flex justify-end'></div>
              }
          </div>
          <div className='w-full rounded p-2 mt-2 bg-[#f5f3ff]'>
              <div className='w-full flex flex-col gap-y-1'>
                  <div className='flex justify-start gap-x-2'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" class="size-5">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
       <p className=' flex text-xs font-normal text-[#6C6580] mt-0.5 w-full'>
       <p className="w-[75%]"> Working Hour </p> <p className="w-[25%]">:  {item?.working_hours}</p>
       </p>
                  </div>
                  <div className='flex justify-start gap-x-2'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="gray" stroke-width="1.5"  class="size-5">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
               <p className=' flex text-xs font-normal text-[#6C6580] mt-0.5 w-full'>
                      <p className="w-[75%]"> Amount Per-Hour </p> <p className="w-[25%]">:  {item?.amount_per_hour}</p>
                      </p>
                  </div>
                  {/* <div className='flex justify-start gap-x-2'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                          <path d="M15.2909 14.3647L11.7729 17.8837C11.6342 18.0224 11.4696 18.1325 11.2885 18.2076C11.1073 18.2826 10.9131 18.3213 10.717 18.3213C10.5208 18.3213 10.3266 18.2826 10.1455 18.2076C9.96429 18.1325 9.79968 18.0224 9.66105 17.8837L6.143 14.3647C5.54227 13.764 5.06573 13.0509 4.7406 12.2661C4.41546 11.4812 4.24809 10.6401 4.24805 9.79056C4.248 8.94105 4.41528 8.09985 4.74033 7.31498C5.06538 6.53012 5.54184 5.81697 6.1425 5.21624C6.74316 4.61551 7.45626 4.13898 8.24109 3.81384C9.02592 3.4887 9.8671 3.32134 10.7166 3.32129C11.5661 3.32124 12.4073 3.48852 13.1922 3.81357C13.977 4.13862 14.6902 4.61508 15.2909 5.21574C15.8917 5.81644 16.3683 6.5296 16.6934 7.31449C17.0186 8.09938 17.1859 8.94063 17.1859 9.79021C17.1859 10.6398 17.0186 11.481 16.6934 12.2659C16.3683 13.0508 15.8917 13.764 15.2909 14.3647ZM14.236 6.27166C13.3027 5.33835 12.0369 4.81302 10.717 4.81302C9.39706 4.81302 8.13123 5.33735 7.19792 6.27066C6.26461 7.20397 5.74028 8.46981 5.74028 9.78971C5.74028 11.1096 6.26461 12.3754 7.19792 13.3088L10.717 16.8268L14.236 13.3098C14.6982 12.8477 15.0649 12.2991 15.315 11.6953C15.5652 11.0914 15.6939 10.4443 15.6939 9.7907C15.6939 9.13713 15.5652 8.48996 15.315 7.88616C15.0649 7.28235 14.6982 6.73374 14.236 6.27166ZM10.717 11.7811C10.4519 11.7871 10.1883 11.7401 9.94167 11.6428C9.69503 11.5455 9.47031 11.4 9.28071 11.2146C9.0911 11.0293 8.94043 10.808 8.83754 10.5636C8.73465 10.3193 8.68162 10.0568 8.68155 9.79171C8.68149 9.52658 8.73439 9.26411 8.83716 9.01971C8.93992 8.7753 9.09048 8.55389 9.28 8.36848C9.46951 8.18306 9.69416 8.03738 9.94075 7.93998C10.1873 7.84258 10.4509 7.79543 10.716 7.80129C11.236 7.81279 11.7309 8.02742 12.0947 8.39925C12.4585 8.77107 12.6622 9.27053 12.6624 9.79071C12.6625 10.3109 12.459 10.8105 12.0954 11.1825C11.7318 11.5545 11.237 11.7694 10.717 11.7811Z" fill="#7D77B1" />
                      </svg>
                      <p className="text-xs font-normal text-[#6C6580]">
{item?.billing_city 
  ? `${item.billing_city}${item?.billing_postal_code ? `, ${item.billing_postal_code}` : ""}`
  : item?.billing_postal_code || "-"}
</p>
         </div> */}
              </div>
          </div>
      </div>
  )
};



export default CardView;
